import React from 'react';
import ServiceDetail from '../../../components/ServiceDetail/ServiceDetail';
import CTA from '../../../components/CTA/CTA';

const ZohoWidgets = () => {
    return (
        <>
            <ServiceDetail
                title="Zoho Widgets"
                subtitle="Custom Zoho Widgets & UI Solutions"
                description="Widgets are powerful components that enhance the Zoho experience by enabling custom UI, real-time data visibility, and quick actions beyond standard system limitations."
                overview="Zoho Widgets allow businesses to go beyond default Zoho features by adding custom user interfaces, advanced logic, and real-time data interactions."
                features={[
                    { title: "Custom UI Components", description: "Custom interfaces beyond standard Zoho layouts." },
                    { title: "Real-Time Data Display", description: "Live KPIs and insights inside Zoho apps." },
                    { title: "Advanced Logic & Validations", description: "Complex workflows and validations." },
                    { title: "Quick Actions", description: "Perform actions faster with fewer clicks." },
                    { title: "External Integrations", description: "Integrate external systems directly into Zoho." }
                ]}
                benefits={[
                    "Better decision-making",
                    "Reduced manual work",
                    "Improved productivity",
                    "Faster workflows"
                ]}
                technologies={[
                    "Zoho Widgets SDK",
                    "JavaScript",
                    "HTML",
                    "CSS",
                    "Zoho APIs"
                ]}
                process={[
                    { step: "Analysis", description: "Understand business requirements" },
                    { step: "Design", description: "Design widget UI & logic" },
                    { step: "Development", description: "Build custom Zoho widgets" },
                    { step: "Testing", description: "Test data accuracy and performance" },
                    { step: "Deployment", description: "Deploy & support" }
                ]}
            />
            <CTA />
        </>
    );
};

export default ZohoWidgets;
